import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';

@Component({
  templateUrl: 'group-recommeded-lab-tests-popup.component.html'
})

export class GroupRecommendedLabTestPopupComponent implements OnInit {

  constructor( @Inject(MD_DIALOG_DATA) public data: string,
    public dialogRef: MdDialogRef<GroupRecommendedLabTestPopupComponent>) {
  }

  ngOnInit() {
  }

  onCloseConfirm(isConfirm = false) {
    this.dialogRef.close(isConfirm);
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/group-recommended-lab-tests/group-recommeded-lab-tests-popup.component.ts